import {
  CoreFintechUiComponents,
  CORE_FINTECH_UI_NAME,
} from "@b2bportal/core-types";

import { default as FintechMarketplaceSection } from "./FintechMarketplaceSection.module.scss";
import { default as FintechProduct } from "./FintechProduct.module.scss";
import { default as FintechProductBullet } from "./FintechProductBullet.module.scss";
import { default as FintechProductInfoLinksSection } from "./FintechProductInfoLinksSection.module.scss";
import { default as FintechProductOptionsSection } from "./FintechProductOptionsSection.module.scss";

export const CORE_FINTECH_UI_STYLE_OVERRIDES = {
  [CORE_FINTECH_UI_NAME]: {
    [CoreFintechUiComponents.FintechProduct]: FintechProduct,
    [CoreFintechUiComponents.FintechMarketplaceSection]:
      FintechMarketplaceSection,
    [CoreFintechUiComponents.FintechProductOptionsSection]:
      FintechProductOptionsSection,
    [CoreFintechUiComponents.FintechProductInfoLinksSection]:
      FintechProductInfoLinksSection,
    [CoreFintechUiComponents.FintechProductBullet]: FintechProductBullet,
  },
};
